import posthog from "posthog-js"

export function initPosthog() {
  const apiKey = process.env.REACT_APP_POSTHOG_API
  const url = process.env.REACT_APP_POSTHOG_URL

  if (!apiKey || !url) return

  const isProd = process.env.REACT_APP_USER_ENVIRONMENT === "production"

  if (!isProd) {
    console.log("Skipping PostHog init in non-production environment")
    return
  }

  posthog.init(apiKey, {
    api_host: url,
    person_profiles: "identified_only",
  })
}
